import { render, staticRenderFns } from "./OrderContentTop.vue?vue&type=template&id=71a870e6&"
import script from "./OrderContentTop.vue?vue&type=script&lang=ts&"
export * from "./OrderContentTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports